import React, { useState } from 'react';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
const faqs = [{
  q: 'In quale anno del corso mi conviene acquistarlo?',
  a: 'In qualsiasi anno. È pensato dal 2° anno (quando iniziano le materie cliniche) fino al neolaureato. Prima lo usi, più mal di testa ti risparmi.'
}, {
  q: 'Non ho soldi adesso, conviene aspettare?',
  a: "L'offerta di oggi (con i 6 bonus inclusi gratis) è a tempo limitato. Domani il pack torna al prezzo normale di $52.690 e i bonus non sono più inclusi."
}, {
  q: 'È solo teoria o posso applicarlo davvero in clinica?',
  a: "È l'opposto dell'università. Ogni capitolo è incentrato sulla clinica reale: protocolli, tabelle, checklist e casi. I modelli puoi usarli letteralmente il giorno dopo."
}, {
  q: 'Serve se non ho ancora iniziato il tirocinio clinico?',
  a: 'Sì. È proprio pensato per farti arrivare al tirocinio con criterio, non con paura. I capitoli 1, 2 e 4 sono fondamentali prima di entrare in clinica.'
}, {
  q: 'Come lo ricevo dopo il pagamento?',
  a: 'Appena confermi il pagamento ricevi via email un link di download immediato con tutti i PDF (6 moduli + 6 bonus). È 100% digitale, non viene spedito nulla di fisico.'
}, {
  q: 'Posso aprirlo su cellulare, tablet e computer?',
  a: 'Sì. Sono PDF ottimizzati per essere letti su qualsiasi dispositivo e puoi anche stamparli. Molti studenti li usano sul cellulare durante il turno.'
}, {
  q: "È aggiornato all'Italia e all'Europa?",
  a: 'Sì. Include malattie prevalenti qui (Leishmaniosi, Ehrlichia, Parvovirus, Filariosi) e considerazioni specifiche della pratica veterinaria nella regione.'
}, {
  q: 'E se non mi serve?',
  a: 'Abbiamo una garanzia di soddisfazione. Se dopo aver visionato il materiale senti che non faceva per te, scrivici al supporto e troviamo una soluzione.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full py-16 px-4 bg-gradient-to-b from-sky-50/40 to-white" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <div className="text-center mb-10" data-id="element-80">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-100 text-green-800 font-bold text-sm mb-4" data-id="element-81">
            <HelpCircleIcon className="w-4 h-4" data-id="element-82" /> DOMANDE FREQUENTI
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-83">
            I tuoi dubbi, chiariti
          </h2>
        </div>

        <div className="space-y-3" data-id="element-84">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={i} className={`rounded-xl border-2 transition-all overflow-hidden ${isOpen ? 'border-green-400 bg-white shadow-md' : 'border-slate-200 bg-white'}`} data-id="element-85">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-86">
                  <span className="font-bold text-slate-900 text-sm sm:text-base" data-id="element-87">
                    {f.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 text-green-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-88" />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-89">
                  <div className="overflow-hidden" data-id="element-90">
                    <p className="px-5 pb-5 text-slate-600 text-sm sm:text-base leading-relaxed" data-id="element-91">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-10" data-id="element-92">
          <BuyButton label="VOGLIO ACCEDERE ORA" data-id="element-93" />
        </div>
      </div>
    </section>;
}